import type {
  CustomerBalanceResponse,
  TransactionHistoryResponse,
  LoyaltyPolicyResponse,
  ProductCreditPreview,
} from '../../../model/loyalty/loyalty';
import type { Currency, TransactionCategory } from '../../../constants';

// GET /loyalty/customers/{customerId}/balance
export type GetCustomerBalanceRequest = {
  customerId: string;
  /** Display currency for credit conversion (defaults to SGD on the server). */
  currency?: Currency;
};

export type GetCustomerBalanceResponse = CustomerBalanceResponse;

// GET /loyalty/customers/{customerId}/transactions
export type GetTransactionHistoryRequest = {
  customerId: string;
  limit?: number;
  lastEvaluatedKey?: string;
  /** Display currency for credit conversion (defaults to SGD on the server). */
  currency?: Currency;
  /** History bucket to return (defaults to `all` on the server). */
  category?: TransactionCategory;
};

export type GetTransactionHistoryResponse = TransactionHistoryResponse;

// GET /loyalty/policy
export type GetLoyaltyPolicyRequest = {
  currency: Currency;
};

export type GetLoyaltyPolicyResponse = LoyaltyPolicyResponse;

export type GetProductCreditPreviewRequest = {
  productId: string;
  currency?: Currency;
};

export type GetProductCreditPreviewResponse = ProductCreditPreview;
